"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotTrustedHost = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Link_1 = require("@skbkontur/react-ui/components/Link");

var PluginHint_module_css_1 = tslib_1.__importDefault(require("./PluginHint.module.css"));

var PluginSetup_1 = require("../../Control/PluginSetup");

exports.NotTrustedHost = function (_a) {
  var addToTrustedLink = _a.addToTrustedLink;

  var confirm = function confirm() {
    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
      var ps;
      return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            ps = new PluginSetup_1.PluginSetup();
            return [4
            /*yield*/
            , ps.confirmAccessPopup()];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return react_1.default.createElement("div", {
    className: PluginHint_module_css_1.default.pad
  }, "\u0427\u0442\u043E\u0431\u044B \u0443\u0432\u0438\u0434\u0435\u0442\u044C \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u044B, \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044B\u0435 \u043D\u0430\xA0\u043A\u043E\u043C\u043F\u044C\u044E\u0442\u0435\u0440\u0435, \u0440\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u0432\xA0", react_1.default.createElement(Link_1.Link, {
    onClick: confirm
  }, "\u0434\u0438\u0430\u043B\u043E\u0433\u043E\u0432\u043E\u043C \u043E\u043A\u043D\u0435"), " \u0438\u043B\u0438\xA0\u0437\u0430\u043F\u0443\u0441\u0442\u0438\u0442\u0435 \u0444\u0430\u0439\u043B", ' ', react_1.default.createElement(Link_1.Link, {
    href: addToTrustedLink
  }, "\u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438"));
};